<template>
    <div class="filling-goods-div">
        <div style="padding-top: 5px; font-size: 16px">面料发货单详情页</div>
        <div class="goodsorder-head">
            <div class="goodsorder-list">装箱单号:
                <div class="goodsorder-number">{{ out_num }}</div>
            </div>
        </div>
        <span style="color: red" v-if="hostcs">测试服</span>
        <div style="display: flex; justify-content: space-between; align-items: center">
            <van-button type="info" size="small" style="display: flex" :text="ray" @click="holdRay()"></van-button>
            <div>
                <input id="reel-input" class="get-input-reel" @keyup.enter="ScanReel(reeldata)" ref="getIDInpot"
                    v-model="reeldata" v-on:blur="hideMessage('reeldata')" readonly autocomplete="off" />
            </div>
        </div>

        <div :style="style">
            <div v-for="(items, index) in listdata" :key="index">
                <div style="display: flex; align-items: flex-end; margin-top: 10px;">
                    <div style="font-weight: bold;">货号:</div>
                    <div>{{ index }}</div>
                </div>
                <div class="reel-info-two" v-for="(i, indexs) in items" :key="indexs">
                    <div class="info-order-div-out">
                        <span class="info-order-out">
                            <div style="font-weight: bold; width: 35px;">卷号:</div>
                            <div>{{ i.reel }}</div>
                        </span>
                        <span class="info-order-out">
                            <div style="font-weight: bold; width: 35px;">数量:</div>
                            <div>{{ i.num }} 米</div>
                        </span>
                        <span class="info-order-out" style="width: 100%; align-items: center;">
                            <div style="font-weight: bold; width: 35px;">备注:</div>
                            <!-- <input type="text" v-model="i.bz" style="width: 80%; height: 20px;"> -->
                            <div>{{ i.bz }}</div>
                        </span>
                    </div>
                    <div>
                        <!-- <van-icon name="cross" @click="deleteData(index, i['gck_number'])" style="margin: 5px 0" /> -->
                        <div :class="{ 'ok': i.sign == 1 }">
                            {{ i.sign == 1 ? '已扫描' : '' }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="filling-goods-bottom" style="display: flex">
            <van-button type="warning" class="bottom-button" @click="go_index()">返回</van-button>
            <van-button type="info" class="bottom-button" @click="ConfirmOut()">确认出库</van-button>
            <!-- <van-button
            v-if="outNumber !== '未出库'"
            type="default"
            class="bottom-button"
            style="background-color: darkgray"
            >确认出库</van-button
          >
          <van-button
            v-if="outNumber !== '未出库'"
            type="info"
            class="bottom-button"
            @click="revocation(id)"
            >撤销出库</van-button
          >
          <van-button
            v-if="outNumber === '未出库'"
            type="default"
            class="bottom-button"
            style="background-color: darkgray"
            >撤销出库</van-button
          >
          <van-button
            type="warning"
            class="bottom-button"
            style="margin: 0"
            @click="more_show = true"
          >
            更多
          </van-button>
          <van-button
            class="bottom-button"
            type="warning"
            style="width: 10%"
            @click="resetClick()"
          >
            +
          </van-button> -->
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import { mapState, mapMutations } from "vuex";
import { Dialog } from "vant";
import { Toast } from "vant";
export default {
    name: "FabricOutDetail",
    data() {
        return {
            hostcs: false,
            more_show: false,
            ray: "扫描中",
            id: "",
            style: "",
            infoType: "1111",
            username: "",
            type: "FabricOutDetail",
            loading: true,
            lizi: [],
            //xin
            listdata: {},
            reeldata: "",
            out_num: '',
            out_id: '',
            data: [],
            reeldata_haveAll: {},
            showConfirm: false,
            SingleData: '',
            PickGoodsType: true,//防止拣货多次点击连续出库问题
        };
    },
    mounted() {
        if (typeof this.$route.query.out_num !== 'undefined') {
            this.out_num = this.$route.query.out_num;
            this.out_id = this.$route.query.out_id;
            this.getReel(this.out_id);
            //console.log(this.orderdata);
        }
        this.username = JSON.parse(window.localStorage.getItem("userinfo"));
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.style =
            "text-align: left;width: 100%;height: " + h * 0.66 + "px;overflow:scroll";
        setTimeout(() => {
            this.focus();
        }, 500);
        if (window.location.host.indexOf("cspda") !== -1) {
            this.hostcs = true;
        }
    },
    methods: {
        getReel(index) {  //获取全部该装箱单的卷号
            this.get(this.APIOBJ.outDetailZp, {
                id: index,
            }).then((res) => {
                if (res.data.status == 1) {
                    this.lizi = res.data.data.out_detail;
                    for (const item of this.lizi) {
                        if (!this.listdata[item.number]) {
                            this.$set(this.listdata, item.number, []);
                        }
                        this.listdata[item.number].push(item);
                    }
                    //this.$forceUpdate();
                    console.log('1', this.listdata)
                } else {
                    Toast(res.data.msg);
                }
            });
        },
        ScanReel(reeldata) {
            const isReelExist = (reel) => {
                return this.lizi.some((item) => {
                    return item.reel === reel;
                });
            };
            console.log(isReelExist(reeldata));
            if (!isReelExist(reeldata)) {
                Dialog.alert({
                    message: "抱歉,当前扫描的卷号条码不属于该出库单,请核实后重新扫描或联系相关人员进行确认!",
                })
                this.reeldata = '';
            } else {
                const filteredData = this.lizi.filter(item => item.reel === reeldata);// 将筛选出的数据的 id字段取出来
                this.get(this.APIOBJ.reelOut, {
                    id: filteredData[0].id,
                    reel: reeldata,
                }).then((res) => {
                    if (res.data.status == 1) {
                        const odk = this.lizi.findIndex(item => item.reel === reeldata);
                        if (odk !== -1) {// 如果存在符合条件的数据，则将其 sign 字段修改为 1
                            //this.listdata={};
                            this.lizi.forEach(item => {
                                if (item.reel === reeldata) {
                                    item.sign = 1;
                                }
                            });
                        }
                        Toast(res.data.msg);
                        this.reeldata = '';
                    } else {
                        Toast(res.data.msg);
                        this.reeldata = '';
                    }
                });
            }
        },
        // deleteData(index) {
        //     Dialog.confirm({
        //         message: "确定要删除该卷号吗？",
        //     }).then(() => {
        //         let mxm = this.data[index].reel;
        //         this.data.splice(index, 1);
        //         delete this.reeldata_haveAll[mxm];
        //     }).catch(() => {
        //         // on cancel
        //     });
        // },
        // delPick() {
        //     delete this.reeldata_haveAll[this.reeldata];
        //     this.reeldata = "";
        //     this.showConfirm = false;
        // },

        async ConfirmOut() {
            // console.log(this.data);
            // if (this.data.length === 0) {
            //     return;
            // };
            if (!this.PickGoodsType) {
                Toast("不要连续出库");
                return;
            };
            if (!this.lizi.every((item) => item.sign == 1)) {
                Toast("还有未扫描的卷号");
                return;
            };
            this.PickGoodsType = false;
            this.get(this.APIOBJ.chuOuts, {
                id: this.out_id,
                user_name: JSON.parse(window.localStorage.getItem("userinfo")),
            }).then((res) => {
                if (res.data.status == 1) {
                    console.log(res.data);
                    this.PickGoodsType = true;
                    Toast(res.data.msg);
                    setTimeout(() => {
                        this.$router.go(-1);
                    }, 200);
                } else {
                    Toast(res.data.msg);
                }
            });
        },
        hideMessage(title) {
            if (title === "reeldata") {
                if (this.reeldata === "") {
                    this.ray = "已暂停，点击我继续扫码";
                }
            }
            if (title === "gck_number_data") {
                if (this.gck_number_data === "") {
                    this.ray = "已暂停，点击我继续扫码";
                }
            }
        },
        holdRay() {
            this.ray = "扫描中";
            if (this.reeldata === "") {
                this.focus();
            } else if (this.gck_number_data === "") {
                this.gck_input();
            }
        },
        focus() {
            this.$refs.getIDInpot.focus();
            this.$refs.getIDInpot.setAttribute("readonly", "readonly");
            setTimeout(() => {
                this.$refs.getIDInpot.removeAttribute("readonly");
            }, 200);
        },
        go_index() {
            Dialog.confirm({
                message: "确定要回上一页吗？",
            })
                .then(() => {
                    this.$router.push("/FabricOutList");
                })
                .catch(() => {
                    // on cancel
                });
        },
    },
};
</script>

<style lang="less">
@import "../style/outOrderInfo.less";

.goodsorder-list {
    display: flex;
    text-align: left;
    padding: 10px 10px 0px 10px;
    //height: 20px;
    align-items: center;
}

.reel-info-two {
    margin: 10px;
    background-color: #f2f2f2;
    //padding: 0 10px 10px 10px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.get-input-reel {
    height: 20px;
    width: 3rem
}

.goodsorder-number {
    display: flex;
    background-color: rgb(221, 220, 220);
    width: 70%;
    align-items: center;
    justify-content: center;
    margin: 0px 10px 0px 10px;
    height: 20px;
}

.goodsorder-head-div {
    display: flex;
    padding: 0px 10px 0px 10px;
    margin: 10px 0 10px 0;
    background-color: rgb(240, 239, 239);
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
}

.goodsorder-head {
    margin: 10px 0 30px 0;
}

.head-list-div {
    width: 32%;
    padding: 10px 0 10px 0;
}

.dialog-div {
    padding: 10px 30px;
    display: flex;
}

// .dialog-div{
//   padding: 10px 20px;
//   display: flex;
// }
.info-order-div-out {
    width: 80%;
    display: flex;
    padding-top: 5px;
    padding-bottom: 5px;
    align-items: center;
    flex-wrap: wrap;
}

.ok {
    color: green;
}

.info-order-out {
    padding: 10px;
    display: flex;
    width: 40%;
    display: flex;
    align-items: flex-end;
}

.van-dialog__header {
    padding-top: 25px;
    font-weight: 500;
    text-align: center;
    font-size: 18px;
}
</style>